import { createFileRoute } from '@tanstack/react-router'
import * as z from 'zod'

import { ReportsDeficitPage } from '@/features/reports/pages/reports-deficit-page'
import { messages } from '@/lib/i18n/messages'

const SearchSchema = z.object({
  project_id: z.coerce.number().optional(),
})

// `<Shell>` and `requireAuth` live on the shared `/_app` layout, so this leaf
// renders only the page — the sidebar stays mounted across every global
// navigation (see routes/_app.tsx).
export const Route = createFileRoute('/_app/reports/deficit')({
  validateSearch: SearchSchema,
  staticData: { crumb: messages.reports.deficit.title },
  component: ReportsDeficitPage,
})
